import {
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {ShortcutMenu} from '@app/domain/shortcut-menu';
import {Observable, Subject, takeUntil} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {SesionState} from '@app/state/sesion/sesion.state';
import {LoginService} from '@app/service/login.service';
import {ShortcutService} from '@app/service/shortcut.service';
import {MenuItem, MessageService} from 'primeng/api';
import {environment} from '@env/environment';
import {SetStatusClientWhatsappEvolution} from '@app/state/sesion/sesion.actions';
import {ConfigCompany} from '@app/domain/config-company';
import {SocketIoService} from '@app/service/socket-io.service';
import {EventEnum} from '@app/enums/event.enum';
import {WhatsappService} from '@app/service/whatsapp.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    shortcuts: ShortcutMenu[] = [];

    // tslint:disable-next-line:variable-name
    _roles: any[];
    urlImageLogo: string;

    @Select(SesionState.getConfig) configCompany$: Observable<ConfigCompany>;
    configCompany: ConfigCompany = {};

    @Select(SesionState.getStatusClientWhatsappEvolution) statusClientWhatsappstatusEvolution$: Observable<'open' | 'close' | 'connecting'>;

    @Select(SesionState.getAppVersion) appVersion$: Observable<string>;

    shortcutsMenuItems: MenuItem[] = [];

    statusClientPrinterCoffe: boolean;
    statusClientWhatsapp: boolean;
    WhatsappClientLogued = false;

    WhatsappEvolucionInstance = false;
    WhatsappEvolucionLogued = false;

    @Input()
    set roles(roles: any[]) {
        this._roles = roles;
        this.loadShortcuts();
    }

    get roles() {
        return this._roles;
    }

    constructor(public appMain: AppMainComponent, private loginService: LoginService,
                private store: Store,
                private shortcutService: ShortcutService,
                private messageService: MessageService,
                private socketIoService: SocketIoService,
                private whatsappService: WhatsappService
            ) {}

    ngOnInit(): void {
        this.configCompany$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(c => {
                this.configCompany = c;
                if (this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION'){
                    this.whatsappService.getStatusInstanceWhatsapp().subscribe(data => {
                        if (data.instance.state === 'connecting') {
                            this.messageService.add({severity: 'info', summary: 'Informacion', detail: 'No se puede conectar con el servidor de whatsapp, intentando conectar manualmente'});
                        }
                        if (data.instance.state === 'close') {
                            this.messageService.add({severity: 'warn', summary: 'Advertencia', detail: 'El servidor de whatsapp no se encuentra conectado, por favor conectese', life: 5000});
                        }
                        this.WhatsappEvolucionLogued = data.instance.state === 'open';
                        this.store.dispatch(new SetStatusClientWhatsappEvolution(data.instance.state));
                    },
                    error => {
                        console.error(error);
                        // sin respuesta del servidor no hay sesión: corrige el estado
                        // persistido para que el indicador no quede en verde
                        this.WhatsappEvolucionLogued = false;
                        this.store.dispatch(new SetStatusClientWhatsappEvolution('close'));
                        if (error.status === 404) {
                            this.messageService.add({severity: 'info', summary: 'Info', detail: 'Registro de numero necesario, registrese para poder enviar mensajes'});
                            return;
                        }
                        this.messageService.add({severity: 'error', summary: 'Error', detail: 'No se pudo establecer conexión con el servidor de whatsapp'});
                    });
                }
            });
        this.urlImageLogo = environment.urlLogo;

        this.statusClientWhatsappstatusEvolution$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                this.WhatsappEvolucionLogued = data === 'open';
            });
        this.socketIoService.onEvent(EventEnum.STATUS_CLIENT_PRINTER)
            .pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(data => {
                console.log(data);
                this.statusClientPrinterCoffe = data;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    get isTypeClientPrintCoffe() {
        return this.configCompany?.clienteImpresion === 'COFFE' || this.configCompany?.clienteImpresion === 'COFFE_LOCAL';
    }

    get whatsappVisible() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION'
            || (this.configCompany?.tipoClienteWhatsapp === 'SOCKET' && this.statusClientWhatsapp);
    }

    get whatsappConnected() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION' ? this.WhatsappEvolucionLogued : this.WhatsappClientLogued;
    }

    get whatsappRoute() {
        return this.configCompany?.tipoClienteWhatsapp === 'EVOLUTION' ? '/whatsapp/whatsapp-login' : '/whatsapp/estado-session';
    }

    get inlineShortcuts() {
        return this.shortcuts.slice(0, 4);
    }

    onAvatarError(event: Event) {
        (event.target as HTMLImageElement).src = 'assets/layout/images/default-avatar.png';
    }

    loadShortcuts() {
        if (this.roles) {
            this.shortcutService.findAll(this.loginService.getUser().empresa.id, false).subscribe(data => {
                this.shortcuts = data;
                this.shortcuts.forEach(s => {
                    const rolesRequired = s.roles.split(',');
                    let visible = false;
                    rolesRequired.forEach(rr => {
                        if (this.roles.find(r => r === rr)) {
                            visible = true;
                        }
                    });
                    s.visible = visible;
                });
                this.shortcuts = this.shortcuts.filter(s => s.visible);
                this.buildShortcutsMenu();
            });
        }
    }

    private buildShortcutsMenu() {
        // el menú lleva la lista completa: en desktop complementa los iconos
        // visibles y en móvil es el único punto de acceso
        const items: MenuItem[] = this.shortcuts
            .map(s => ({label: s.nombre, icon: s.icono, routerLink: s.ruta}));
        this.shortcutsMenuItems = [
            ...items,
            ...(items.length ? [{separator: true} as MenuItem] : []),
            {label: 'Personalizar accesos', icon: 'pi pi-cog', routerLink: '/accesos-directos'}
        ];
    }

}
